<ngx-spinner [fullScreen]="false"
             type="ball-clip-rotate-multiple"
             bdColor="rgba(51,51,51,0.8)"
             size="medium"
             color="#fff"></ngx-spinner>
<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100" fxLayout="column">
    <Teranet-PageTitle [PageTitle]="pageTitle"></Teranet-PageTitle>
    <form [formGroup]="userForm" #createclientform="ngForm" novalidate>
      <div class="mat-elevation-z4">
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <Teranet-ClientTitle [ClientTitle]="'User Profile'" [IconName]="'user'"></Teranet-ClientTitle>
            <div *ngIf="hasError" class="alert alert-danger" role="alert">
              <div>
                <fa-icon icon="times"
                         id="errorIcon"
                         class="fa-lg"
                         matTooltipPosition="above"></fa-icon>
                &nbsp;Your data could not be saved because the following error(s) were found:
              </div>
              <div>
                <ul>
                  <li *ngFor="let errorMessage of errorMessages; let j = index">
                    {{ errorMessage }}
                  </li>
                </ul>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <h5>User Details</h5>
              <mat-divider></mat-divider>
              <br />
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">User Name</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="userName"
                         required
                         (blur)="updateEmailAddress()"
                         #userName />
                  <mat-error *ngIf="userForm.get('userName').hasError('required')">
                    {{ userErrorMessage.USER_NAME_REQUIRED }}
                  </mat-error>
                  <mat-error *ngIf="userForm.get('userName').hasError('invalidEmail')">
                    {{ emailErrorMessage.IS_NOT_EMAIL }}
                  </mat-error>
                  <mat-error *ngIf="userForm.get('userName').hasError('invalidDomain')">
                    {{ emailErrorMessage.EMAIL_DOMAIN }}
                  </mat-error>
                  <mat-error *ngIf="!isEdit && userForm.get('userName').hasError('userEmailExists')">
                    {{ userErrorMessage.USER_NAME_EXISTS }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column" [hidden]="isEdit">
                <mat-label class="required-field-after">Password</mat-label>
                <mat-form-field appearance="outline" *ngIf="!isEdit">
                  <input matInput
                         data-lpignore="true"
                         formControlName="password"
                         required
                         #password />
                  <mat-error *ngIf="!isEdit && userForm.get('password').hasError('required')">
                    {{ passwordErrorMessage.PASSWORD_REQUIRED }}
                  </mat-error>
                  <mat-error *ngIf="!isEdit && userForm.get('password').hasError('pattern')">
                    {{ passwordErrorMessage.IS_NOT_PASSWORD }}
                    <div class="password-hint">
                      <div id="divPasswordInfo">
                        <strong>Password</strong> must meet the following minimum password strength requirements:<br />
                        <ul>
                          <li>Contain at least 1 lowercase character</li>
                          <li>Contain at least 1 special character (@ % + \ / ! $ &amp; ? [ ])</li>
                          <li>Contain at least 1 digit</li>
                          <li>Contain at least 1 uppercase character</li>
                          <li>Does not contain any characters other than those mentioned above</li>
                          <li>At least 10 characters in length</li>
                        </ul>
                      </div>
                    </div>
                  </mat-error>
                </mat-form-field>
                <div [ngClass]="{'margin-top-150': userForm.controls['password'].hasError('pattern')}"></div>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">First Name</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="firstName"
                         required
                         #firstName />
                  <mat-error *ngIf="userForm.get('firstName').hasError('required') || userForm.get('firstName').hasError('whitespace')">
                    {{ userErrorMessage.FIRST_NAME_REQUIRED }}
                  </mat-error>
                  <mat-error *ngIf="userForm.get('firstName').hasError('maxlength')">
                    {{ userErrorMessage.FIRST_NAME_MAX_LENGTH + userForm.get('firstName').errors.maxlength.requiredLength }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label>Middle Name</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="middleName"
                         #middleName />
                  <mat-error *ngIf="userForm.get('middleName').hasError('whitespace')">
                    {{ userErrorMessage.MIDDLE_NAME_WHITESPACE }}
                  </mat-error>
                  <mat-error *ngIf="userForm.get('middleName').hasError('maxlength')">
                    {{ userErrorMessage.MIDDLE_NAME_MAX_LENGTH + userForm.get('middleName').errors.maxlength.requiredLength }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Last Name</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="lastName"
                         required
                         #lastName />
                  <mat-error *ngIf="userForm.get('lastName').hasError('required') || userForm.get('lastName').hasError('whitespace')">
                    {{ userErrorMessage.LAST_NAME_REQUIRED }}
                  </mat-error>
                  <mat-error *ngIf="userForm.get('lastName').hasError('maxlength')">
                    {{ userErrorMessage.LAST_NAME_MAX_LENGTH + userForm.get('lastName').errors.maxlength.requiredLength }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label>Email</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="email"
                         #email />
                  <mat-error *ngIf="userForm.get('email').hasError('invalidEmail')">
                    {{ emailErrorMessage.IS_NOT_EMAIL }}
                  </mat-error>
                  <mat-error *ngIf="userForm.get('email').hasError('invalidDomain')">
                    {{ emailErrorMessage.EMAIL_DOMAIN }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label>Phone Number</mat-label>
                <mat-form-field class="mat-form-field-md" appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="phone"
                         #phone />
                  <mat-error *ngIf="userForm.get('phone').hasError('invalidPhone')">
                    {{ userErrorMessage.IS_NOT_PHONE_NUMBER }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label>Ext.</mat-label>
                <mat-form-field class="mat-form-field-sm" appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="ext"
                         #ext />
                  <mat-error *ngIf="userForm.get('ext').hasError('invalidExtension')">
                    {{ userErrorMessage.IS_NOT_PHONE_EXTENSION }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Language</mat-label>
                <mat-form-field appearance="outline">
                  <mat-select required
                              formControlName="language"
                              placeholder="--Please Select--"
                              #languageRef
                              [disabled]="true">
                    <mat-option *ngFor="let language of languages" [value]="language">
                      {{ language }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="userForm.get('language').hasError('required')">
                    {{ userErrorMessage.LANGUAGE_REQUIRED }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Province</mat-label>
                <mat-form-field appearance="outline">
                  <mat-select required
                              formControlName="provinceId"
                              placeholder="--Please Select--"
                              #province>
                    <mat-option *ngFor="let province of provinces" [value]="province.id">
                      {{ province.description }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="userForm.get('provinceId').hasError('required')">
                    {{ userErrorMessage.PROVINCE_REQUIRED }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <h5>Role and Business Scope</h5>
              <mat-divider></mat-divider>
              <br />
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Corporation</mat-label>
                <mat-form-field class="col-md-20" appearance="outline">
                  <mat-select required
                              formControlName="clientInfoId"
                              placeholder="--Please Select--"
                              #corporation
                              [disabled]="isEdit || isCopy "
                              (selectionChange)="getCorporationRoles()">
                    <mat-option *ngFor="let clientInfo of clientInfoDescriptions" [value]="clientInfo.id">
                      {{ clientInfo.description }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="!isEdit && userForm.get('clientInfoId').hasError('required')">
                    {{ userErrorMessage.CORPORATION_REQUIRED }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Role</mat-label>
                <mat-form-field class="col-md-20" appearance="outline">
                  <mat-select required
                              formControlName="roleId"
                              placeholder="--Please Select--">
                    <mat-option *ngFor="let role of roles" [value]="role.id">
                      {{ role.displayName }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="userForm.get('roleId').hasError('required')">
                    {{ userErrorMessage.ROLE_REQUIRED }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <h5>Account Details</h5>
              <mat-divider></mat-divider>
              <br />
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label>User Status</mat-label>
                <mat-form-field appearance="outline">
                  <mat-select formControlName="status"
                              placeholder="--Please Select--">
                    <mat-option *ngFor="let status of userStatuses()"
                                [value]="status"
                                [disabled]="status === 'Inactive'
                                || (status === 'Disabled' && userForm.get('status') !== null && userForm.get('status').value === 'Inactive')">
                      {{ status }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label>Account State</mat-label>
                <mat-form-field appearance="standard">
                  <mat-label *ngIf="!isLocked" #lockstatus>Unlocked</mat-label>
                  <mat-label *ngIf="isLocked" #lockstatus>Locked</mat-label>
                  <input matInput
                         formControlName="accountState"
                         readonly
                         disabled="disabled" />
                  <mat-icon matSuffix>lock</mat-icon>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <button mat-button
                        class="plain-button"
                        [disabled]="!isLocked"
                        (click)="unlockUser()">
                  Unlock
                </button>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label>Password Expiry Date/Time</mat-label>
                <mat-form-field appearance="standard">
                  <mat-label>{{ changePasswordDate }}</mat-label>
                  <input matInput
                         readonly
                         disabled="disabled" />
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label>Created Date/Time</mat-label>
                <mat-form-field appearance="standard">
                  <mat-label>{{ createdDate | date: 'yyyy-MM-dd HH:mm:ss' }}</mat-label>
                  <input matInput
                         readonly
                         disabled="disabled" />
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label>Last Login Date/Time</mat-label>
                <mat-form-field appearance="standard">
                  <mat-label>{{ lastLoginDate }}</mat-label>
                  <input matInput
                         readonly
                         disabled="disabled" />
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label>Privacy Policy Agreed Date/Time</mat-label>
                <mat-form-field appearance="standard">
                  <mat-label>{{ policyAgreedDate }}</mat-label>
                  <input matInput
                         readonly
                         disabled="disabled" />
                </mat-form-field>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <button mat-raised-button
                        class="plain-button"
                        type="button"
                        *ngIf="isEdit"
                        (click)="resetPassword()">
                  Reset Password
                </button>
              </div>
              <div class="form-group-flex-column">
                <mat-checkbox formControlName="forcePassword"
                              class="checkbox-margin">
                  Force password change on next login
                </mat-checkbox>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="end center" fxFlex="100">
              <button mat-raised-button class="plain-button-lg" type="button" (click)="goToUser()">Cancel</button>
              <button mat-raised-button class="theme-button-lg" type="submit" (click)="createOrUpdateUser()">Save</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
